export const VALID_INVOICES_OPTIONS = [
	{ label: 'To accept', value: 'open' },
	{ label: 'Accepted', value: 'done' },
];
